/*
Lang conventions

- No magic user-facing text in code. UI copy should go through `src/lang`.
- Do not leave user-visible English text inline in `components`, `views`, `store`, `helpers`, `classes`, or `settings`.
- Use `Lang.*` in code and add the source string in the correct file below.

File map

- `actions.ts`: action-menu items and verb-like commands.
- `buttons.ts`: button labels and short CTA text.
- `confirmations.ts`: destructive confirmations and leave/reset/delete prompts.
- `datePresets.ts`: named date range presets only.
- `dialogs.ts`: structured modal/dialog content objects.
- `errors.ts`: validation text and field-level errors.
- `filters.ts`: filter vocabulary and range wording.
- `formatters.ts`: formatting output tokens like NULL / UNKNOWN / TBD.
- `hints.ts`: inline hints, warnings, explanatory helper text.
- `inputs.ts`: form labels, filter labels, select option titles, configuration labels, generic UI nouns.
- `legends.ts`: chart/table legend vocabulary.
- `links.ts`: link text and link-like CTA copy.
- `messages.ts`: alerts, toasts, success/error/info messages, async/runtime feedback.
- `placeholders.ts`: true input placeholder text only.
- `roles.ts`: displayed role names only.
- `routes.ts`: route and menu display names only.
- `tables.ts`: table header labels and table-specific grouped text.
- `titles.ts`: page titles, section titles, widget titles, drawer titles, card titles.
- `tooltips.ts`: hover text and icon-button descriptions.

Granularity rules

- Prefer the most specific existing file over dumping everything into `messages.ts` or `titles.ts`.
- If a new cluster does not fit cleanly, create a new dedicated `src/lang/<topic>.ts` file.
- Group by user-facing intent, not by component name.
- Avoid duplicate keys for the same wording unless the product meaning is actually different.

Do not put into lang

- API field names, payload keys, route ids, metric ids, enum values, storage keys, or other technical identifiers.
- Strings persisted as business data rather than displayed copy.
- Third-party template syntax such as chart placeholders like `"{valueY}"`.
*/
import actions from "@/lang/actions";
import buttons from "@/lang/buttons";
import confirmations from "@/lang/confirmations";
import datePresets from "@/lang/datePresets";
import dialogs from "@/lang/dialogs";
import errors from "@/lang/errors";
import filters from "@/lang/filters";
import formatters from "@/lang/formatters";
import hints from "@/lang/hints";
import inputs from "@/lang/inputs";
import legends from "@/lang/legends";
import links from "@/lang/links";
import messages from "@/lang/messages";
import placeholders from "@/lang/placeholders";
import roles from "@/lang/roles";
import routes from "@/lang/routes";
import tables from "@/lang/tables";
import titles from "@/lang/titles";
import tooltips from "@/lang/tooltips";

export default {
  locale: "en",
  ...actions,
  ...confirmations,
  ...titles,
  ...messages,
  ...links,
  ...buttons,
  ...errors,
  ...inputs,
  ...routes,
  ...tables,
  ...roles,
  ...dialogs,
  ...datePresets,
  ...legends,
  ...formatters,
  ...placeholders,
  ...tooltips,
  ...filters,
  ...hints,
};
